<template>
  <div id="q-app">
    <router-view />
    <axios-interceptors/>
    <push-handler />
  </div>
</template>
<script>
import AxiosInterceptors from "components/AxiosInterceptors";
import PushHandler from "components/PushHandler";
import {getFcmToken, getUser, storeFcmToken} from "boot/axios";
export default {
  name: 'App',
  components: {PushHandler, AxiosInterceptors},
  async mounted() {
    window.handleOpenURL = (url) => {
      // alert(url)
      this.$router.push(url.replace('waitaha://', '/'))
    }
    try {
      FCM.requestPushPermission();
    } catch {

    }

    let that = this

    window.jQuery(document).on('click', '.info-page-text a', function (e) {
      e.preventDefault()

      let link = window.jQuery(this).attr('href')

      if (link.startsWith('http')) {
        return that.openLink(link)
      }

      link = 'https://waitaha-iwi.org.nz' + link

      that.openLink(link)
    })

    try {
      // eslint-disable-next-line no-undef
      let token = await FCM.getToken()
      storeFcmToken(token)

    } catch (e) {

    }

    getUser().then(r => {
      this.$store.commit('mainStore/user', r)
      getFcmToken()
    })

    this.axiosGet('/settings/dob_required', (r) => {
      this.$store.commit('mainStore/dob_required', r.data.dob_required)
    }, false)

    window.screen.orientation.lock('portrait');
  }
}
</script>
